"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.schemasByID = void 0;
var applicator_json_1 = __importDefault(require("./meta/applicator.json"));
var content_json_1 = __importDefault(require("./meta/content.json"));
var core_json_1 = __importDefault(require("./meta/core.json"));
var format_annotation_json_1 = __importDefault(require("./meta/format-annotation.json"));
var format_assertion_json_1 = __importDefault(require("./meta/format-assertion.json"));
var meta_data_json_1 = __importDefault(require("./meta/meta-data.json"));
var unevaluated_json_1 = __importDefault(require("./meta/unevaluated.json"));
var validation_json_1 = __importDefault(require("./meta/validation.json"));
var schema_json_1 = __importDefault(require("./schema.json"));
exports["default"] = schema_json_1["default"];
var schemas = [
    schema_json_1["default"],
    core_json_1["default"],
    applicator_json_1["default"],
    validation_json_1["default"],
    unevaluated_json_1["default"],
    format_annotation_json_1["default"],
    format_assertion_json_1["default"],
    content_json_1["default"],
    meta_data_json_1["default"]
];
exports.schemasByID = Object.fromEntries(schemas.map(function (schema) { return [schema.$id, schema]; }));
